module.exports = __webpack_public_path__ + "static/the-flute-07afe16e5cf07e53483fb2d570c74cbd.png";